import React, { useState, useEffect } from 'react';
import axios from 'axios';
import toast, { Toaster } from 'react-hot-toast';

import { Button } from "react-bootstrap";
import { useNavigate } from 'react-router-dom';
import { getToken } from '../../utils/auth';

function PaymentCheckoutCriticalSwitch({selectedCurrency, currencySymbol}) {
  const navigate = useNavigate();
  const [plans, setPlans] = useState([]);
  const [selectedPlan, setSelectedPlan] = useState(null);
  const [quantity, setQuantity] = useState(1);
  const [isPopupVisible, setIsPopupVisible] = useState(false);

  const fetchPlans = async () => {
    try {
        const token = getToken();
      const response = await axios.get(`${process.env.REACT_APP_URL}/api/plan/all?platform=critical-D&currency=${selectedCurrency}`, {
        headers: {
          accept: '*/*',
          Authorization: `Bearer ${token}`,
        },
      });
      const filteredPlans = response?.data?.data?.filter(plan => !plan?.isEnrolled)
      setPlans(filteredPlans);
    } catch (error) {
      console.error('Error fetching plans:', error);
    }
  };
 
  const handleFreePlan = async (planId) => {
    try {
      const token = getToken();
      const response = await axios.post(
        `${process.env.REACT_APP_URL}/api/plan/user/${planId}`,
        { platform: 'critical-D' },
        {
          headers: {
            accept: '*/*',
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
          },
        }
      );
      navigate('/plan-success-switch');
     toast.success(response?.data?.message || 'Plan activated successfully!');
    } catch (error) {
      console.error('Error activating free plan:', error);
      toast.error(error?.response?.data?.message || 'Failed to activate the plan. Please try again.');
    }
  };

  const initiatePayment = async () => {
    if (!selectedPlan) {
      toast.error('Please select a plan!');
      return;
    }
    const amount = selectedPlan.firstYearPerMonthRate * quantity;

    if (amount <= 0) {
      await handleFreePlan(selectedPlan._id);
      return;
    }
    try {
      const payload = {
        planId: selectedPlan._id,
        amount: selectedPlan.firstYearPerMonthRate,
        platform: 'critical-D',
        // serviceType: 'sms',
        // quantity,
      };
      const token = getToken();
      const response = await axios.post(`${process.env.REACT_APP_URL}/api/payment/initiate-payment`, payload, {
        headers: {
          accept: '*/*',
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
      });
  
      const paymentUrl = response.data.url; // Extract the URL from the API response
      if (paymentUrl) {
        window.location.href = paymentUrl; // Navigate to the payment page
      } else {
        toast.error('Failed to retrieve payment URL.');
      }
    } catch (error) {
      console.error('Error initiating payment:', error);
      toast.error(error?.response?.data?.message || 'Failed to initiate payment. Please try again.');
    }
  };
  

  useEffect(() => {
    fetchPlans();
  }, [selectedCurrency]);

  return (<>
<Toaster position="top-right" reverseOrder={false}/>


    <div>
      <Button onClick={() => setIsPopupVisible(true)}  style={{ width: '110px' }}>Switch Plan</Button>

      {isPopupVisible && (
        <div
  style={{
    position: 'fixed',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    zIndex: 10000,
    padding: '20px', // Ensures space on smaller screens
    boxSizing: 'border-box',
  }}
>
  <div
    style={{
      backgroundColor: '#fff',
      padding: '20px',
      borderRadius: '8px',
      maxHeight: '90vh', // Dynamically adjust height
      width: '100%', // Full width on smaller screens
      maxWidth: '600px', // Restrict width on larger screens
      boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
      overflowY: 'auto', // Enable scrolling for overflowing content
    }}
  >
            <h2>Select a Plan</h2>
            <div style={{ maxHeight: '350px', overflowY: 'auto' }}>
              {plans?.map((plan) => (
                <div
                  key={plan?._id}
                  style={{
                    marginBottom: '15px',
                    border: `2px solid ${selectedPlan && selectedPlan._id === plan?._id ? '#007BFF' : '#ddd'}`,
                    padding: '10px',
                    borderRadius: '8px',
                    backgroundColor: selectedPlan && selectedPlan._id === plan?._id ? '#f0f8ff' : '#fff',
                  }}
                  onClick={() => setSelectedPlan(plan)}
                >
                  <h3>{plan?.planName} - {currencySymbol} {plan?.firstYearPerMonthRate}/month First Year</h3>
                  <div>
                    <strong>Second Year Annual Price:</strong> {currencySymbol} {plan?.secondYearAnnualRenewPrice}
                  </div>
                  <div>
                    <strong>Dynamic QR Count:</strong> {plan?.dynamicQRCount}
                  </div>
                  <div>
                    <strong>WhatsApp Count:</strong> {plan?.whatsappCount}
                  </div>
                  <div>
                    <strong>SMS Count:</strong> {plan?.smsCount}
                  </div>
                  <div>
                    <strong>Plan Type:</strong> {plan?.planType}
                  </div>
                  
                  <div>
                    <strong>Features:</strong>
                  </div>
                  <ul>
                    {plan?.features?.map((feature, index) => (
                      <li key={index}>{feature}</li>
                    ))}
                  </ul>
                  
                </div>
              ))}
            </div>

            <div style={{ marginTop: '20px', justifyContent:"center", display:"flex" }}>
              <div
                onClick={initiatePayment}
                style={{
                    display:"flex",
                  marginRight: '10px',
                  padding: '10px',
                  justifyContent:"center",
                  backgroundColor: '#007BFF',
                  cursor:"pointer",
                  color: '#fff',
                  border: 'none',
                  borderRadius: '4px',
                  cursor: 'pointer',
                  width:"150px"
                }}
                disabled={!selectedPlan}
              >
                Proceed to Payment
              </div>
              <div
                onClick={() => setIsPopupVisible(false)}
                style={{
                    display:"flex",
                  padding: '10px 20px',
                  justifyContent:"center",
                  backgroundColor: '#6c757d',
                  cursor:"pointer",
                  color: '#fff',
                  border: 'none',
                  borderRadius: '4px',
                  cursor: 'pointer',
                  width:"150px"
                }}
              >
                Cancel
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
    </>
  );
}

export default PaymentCheckoutCriticalSwitch;
